export function createHistoryServiceContext(featureServices) {
    const logger = featureServices['s2:logger'] || console;
    const serverRequest = featureServices['s2:server-request'];
    return { logger, serverRequest };
}
//# sourceMappingURL=history-service-context.js.map